// Pages for the router's own states: loading, not found and unexpected errors.
import { Link, useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Button, Page } from '../ui';

export function LoadingPage() {
  const { t } = useTranslation();
  return (
    <p role="status" className="mx-auto max-w-xl px-4 py-10">
      {t('app.loading')}
    </p>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Page title={t('notFound.title')}>
      <p>{t('notFound.text')}</p>
      <p className="mt-6">
        <Link to="/">{t('notFound.home')}</Link>
      </p>
    </Page>
  );
}

export function ErrorPage() {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <Page title={t('errors.title')}>
      <p className="mb-6">{t('errors.generic')}</p>
      <Button onPress={() => void router.invalidate()}>{t('app.retry')}</Button>
    </Page>
  );
}
